// @ts-check

import { createRandomUuid } from '@/helpers/functions'

/** @type {import('vue').Prop<string|number>} */
export const id = {
  type: [String, Number],
  default: () => createRandomUuid()
}

/** @type {import('vue').Prop<string>} */
export const label = {
  type: String,
  default: null
}

export const errors = {
  type: Array,
  default: () => []
}

/** @param {RemValue} defaultSize */
export const withSize = (defaultSize = '1rem') => ({
  type: String,
  default: defaultSize
})

/** @param {'danger'|'success'|'info'|'primary'|'secondary'} defaultVariant */
export const withVariant = (defaultVariant = 'primary') => ({
  type: /** @type {import('vue').PropType<'danger'|'success'|'info'|'primary'|'secondary'>} */ (
    String
  ),
  default: defaultVariant
})

export const inputProps = {
  id,
  label
}
